@if (header) {
  <h2 class="d-block d-lg-none mb-0" [class.header-top]="marginHeaderTop">{{ header }}</h2>
}

<div class="d-flex align-items-center justify-content-between d-print-none" [class.mb-2]="marginBottom">
  @if (header && leftHeader) {
    <h2 class="d-none d-lg-block mb-0" [class.header-top]="marginHeaderTop">{{ header }}</h2>
  }

  <div class="d-flex gap-3">
    @if (inlineFields?.length > 0) {
      <formly-form
        class="form-inline d-flex align-items-{{ labelsVertical ? 'start' : 'center' }} flex-wrap"
        [class.vertical-labels]="labelsVertical"
        [class.full-width]="fullWidth"
        [form]="form"
        [fields]="inlineFields"
        [model]="model"
        [options]="options"
      ></formly-form>
    }
    <ng-content></ng-content>
  </div>

  @if (header && !leftHeader) {
    <h2 class="d-none d-lg-block mb-0">{{ header }}</h2>
  }
</div>
